/**
 * Shared Monaco defaults for workspace editors.
 *
 * - `accessibilitySupport: 'on'` — always enable the accessibility stack (more consistent
 *   across OS/headless/CI than `'auto'`, which probes the host environment).
 * - `editContext: false` — use the textarea input path so assistive tech and tools that
 *   drive the hidden `.inputarea` (Playwright fill, CDP typing) behave consistently.
 *
 * Automation: focus `[data-testid="…"] textarea.inputarea` (or click inside the editor),
 * then type or fill; the visible editor surface is not a standard text control.
 */
export const WORKSPACE_MONACO_EDITOR_DEFAULTS = {
  accessibilitySupport: 'on' as const,
  editContext: false,
};
